export const AI_TOKEN_USAGE_PATH = "/settings-menu/ai-token-usage";
